import React, { useEffect, useState } from "react";
import { IconCaretLeft, IconCaretRight } from "@tabler/icons";
import { Group, Select, ActionIcon, Button } from "@mantine/core";
import moment from "moment";
import { useTranslation } from "react-i18next";
export const PeriodFilter = ({
  numPeriods = 8,
  numPrevPeriods = 0,
  handlePeriodChange,
  handleRefresh,
  position = "right",
  forward = false,
  by = "Q",
  ...props
}) => {
  const [q, setQ] = useState(numPrevPeriods);
  const [periodFilterOptions, setPeriodFilterOptions] = useState([]);
  const { t } = useTranslation();
  const maxQ = numPrevPeriods + numPeriods - 1;

  const getMonthOffset = (selectedQ) => {
    if (forward && numPrevPeriods > 0) {
      return selectedQ - numPrevPeriods;
    }
    if (forward) return selectedQ;
    return -selectedQ;
  };

  //Set Period Options when initialize
  useEffect(() => {
    setPeriodOptions();
  }, [numPeriods, numPrevPeriods, forward, by]);

  const setPeriodOptions = () => {
    const filters = [];
    if (forward && numPrevPeriods > 0) {
      for (let offset = -numPrevPeriods; offset <= numPeriods - 1; offset++) {
        const d = moment().add(offset, by);
        const value = offset + numPrevPeriods;
        if (by === "Q") {
          filters.push({ label: d.format(`YYYY-[Q]Q`), value });
        }
        if (by === "M") {
          filters.push({ label: d.format(`YYYY-MM`), value });
        }
      }
    } else {
      for (let i = 0; i < numPeriods; i++) {
        const d = forward ? moment().add(i, by) : moment().subtract(i, by);
        if (by === "Q") filters.push({ label: d.format(`YYYY-[Q]Q`), value: i });
        if (by === "M") filters.push({ label: d.format(`YYYY-MM`), value: i });
      }
    }
    setPeriodFilterOptions(filters);
    hanldeQChange(numPrevPeriods > 0 && forward ? numPrevPeriods : 0);
  };

  const hanldeQChange = (selectedQ) => {
    const monthOffset = getMonthOffset(selectedQ);
    let startDate = forward
      ? moment().add(monthOffset - 1, by)
      : moment().subtract(selectedQ + 1, by);

    startDate = startDate.endOf(by).format();

    let endDate = forward
      ? moment().add(monthOffset, by)
      : moment().subtract(selectedQ, by);
    endDate = endDate.endOf(by).format();

    handlePeriodChange({ startDate, endDate });
    setQ(selectedQ);
  };

  return (
    <Group position={position} {...props}>
      <ActionIcon
        size={"xs"}
        onClick={() => hanldeQChange(q - 1 < 0 ? 0 : q - 1)}
      >
        <IconCaretLeft />
      </ActionIcon>
      <Select
        size={"xs"}
        data={periodFilterOptions}
        value={q}
        onChange={hanldeQChange}
        defaultValue={numPrevPeriods > 0 && forward ? numPrevPeriods : 0}
      ></Select>
      <ActionIcon
        size={"xs"}
        onClick={() => hanldeQChange(q + 1 >= maxQ ? maxQ : q + 1)}
      >
        <IconCaretRight />
      </ActionIcon>

      {handleRefresh && (
        <Button size="xs" onClick={handleRefresh}>
          {t("Refresh")}
        </Button>
      )}
    </Group>
  );
};
